import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
  },
  actions: {
    async showConfirmTikTokAccountModal(context, routerInstance) {
      return new Promise(resolve => {
        // Get Vue instance from router
        const vueInstance = routerInstance && routerInstance.app
        if (vueInstance && vueInstance.$bvModal) {
          vueInstance.$bvModal.msgBoxConfirm(
            'You need to connect a TikTok account before accessing the campaign page. Would you like to go to your ads account settings?',
            {
              title: 'TikTok Account Required',
              okTitle: 'Go to Settings',
              cancelTitle: 'Cancel',
              centered: true,
              size: 'sm',
              buttonSize: 'md',
              okVariant: 'primary',
              cancelVariant: 'flat-secondary',
              hideHeaderClose: true,
              modalClass: 'tiktok-account-required-modal',
            },
          ).then(confirmed => {
            resolve(confirmed)
          }).catch(() => {
            resolve(false)
          })
        } else {
          // If no Vue instance available, resolve with false
          resolve(false)
        }
      })
    },
  },
}
